<template>
  <div class="asc-plot-footer-wrapper">
    <asc-plot-footer
      :page-plot="pagePlot"
      :mini-plot="miniPlot"
      :editable="editable"
      :on-update-caption="onUpdateCaption"
      :on-expand="onExpand"
    ></asc-plot-footer>
  </div>
</template>

<script>
import AscPlotFooter from '@/components/molecules/AscPlotFooter'

export default {
  name: 'AscPlotFooterWrapper',

  components: {
    AscPlotFooter,
  },

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },
    miniPlot: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    onUpdateCaption: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
  },

  watch: {
    pagePlot: {
      deep: true,
      handler(newPagePlot) {
        this.pagePlot = newPagePlot
      },
    },
  },
}
</script>
